const API_BASE_URL = process.env.REACT_APP_DATA_SERVICE_URL;
const API_ACTION_URL = process.env.REACT_APP_ACTION_SERVICE_URL
const API_BASE_APP_URL = process.env.REACT_APP_API_BASE_URL_CREATE;
const ACCESS_SERVICE_URL = process.env.REACT_APP_ACCESS_SERVICE_URL
const NOTIFICATION_URL = process.env.REACT_APP_NOTIFICATION_SERVICE_URL;

import axios from 'axios';
import FileDownload from "js-file-download";

import { Request } from "./clientHelper";

export class RolesService {

    static getRoles(data) {
        let uri = ACCESS_SERVICE_URL + `/roles/list`;
        // let localUrl = "http://localhost:5007"
        // let uri = localUrl + `/roles/list`;
        console.log("getRoles === form api", uri)
        let appid = data.appId
        return Request(uri, {
            url: uri,
            method: 'POST',
            headers: {
                appid: appid,
                orgid: data.orgId
            },
            payload: data.payload || {}
        });
    }

    static getRoleById(data) {
        let uri = ACCESS_SERVICE_URL + `/roles/${data.id}`;
        // let localUrl = "http://localhost:5007"
        // let uri = localUrl + `/roles/${data.id}`;
        console.log("getRoles === form api", uri)
        let appid = data.appId
        return Request(uri, {
            url: uri,
            method: 'GET',
            headers: {
                appId: appid,
                orgId: data.orgId
            },
        });
    }
    static deleteRoleById(data) {
        let uri = ACCESS_SERVICE_URL + `/roles/${data.id}`;
        // let localUrl = "http://localhost:5007"
        // let uri = localUrl + `/roles/${data.id}`;
        let appid = data.appId
        return Request(uri, {
            url: uri,
            method: 'DELETE',
            headers: {
                appId: appid,
                orgId: data.orgId
            },
        });
    }
    static createRole(data) {
        let uri = ""
        if (data.id == "new") {
            uri = ACCESS_SERVICE_URL + `/roles`;
            // let localUrl = "http://localhost:5007"
            // uri = localUrl + `/roles`;
        }
        else{
            uri = ACCESS_SERVICE_URL + `/roles/${data.id}`;
            // let localUrl = "http://localhost:5007"
            // uri = localUrl + `/roles/${data.id}`;
        }
        let appid = data.appId
        return Request(uri, {
            url: uri,
            method: data.data._id ? 'PUT' : 'POST',
            payload: data.data,
            headers: {
                appId: appid,
                orgId: data.orgId
            },
        });
    }
}

export function apiBaseAddress() {
    return API_BASE_URL;
}